import React from 'react';
import { useField } from 'formik';
import { i18n } from '@lt/localization';
import styled, { css } from 'styled-components';

const PASSPORT_OPTIONS = {
  internal_passport: i18n.t(
    'checkout.customer.form_fields.doc_types.internal_passport',
  ),
  international_passport: i18n.t(
    'checkout.customer.form_fields.doc_types.international_passport',
  ),
};

type PassportPickerProps = {
  isMobile: boolean;
};

const PassportPicker = (props: PassportPickerProps) => {
  const { isMobile } = props;

  const [field] = useField('docType');

  return (
    <DocumentType $isMobile={isMobile}>
      {PASSPORT_OPTIONS[field.value]}
    </DocumentType>
  );
};

const DocumentType = styled.div<{ $isMobile: boolean }>`
  color: #17181a;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;

  ${(props) =>
    !props.$isMobile &&
    css`
      padding: 0 12px 0 8px;
    `}

  ${(props) =>
    props.$isMobile &&
    css`
      margin-bottom: 4px;
    `}
`;

export default PassportPicker;
